import { httpClient } from "../../../shared/api/httpClient";
import type { SellerOptionResponse } from "../model/types";

export const fetchSellerOptions = async (
  search?: string,
  limit = 100,
): Promise<SellerOptionResponse[]> => {
  const response = await httpClient.get<SellerOptionResponse[]>(
    "/seller-products/sellers",
    {
      params: { search: search?.trim() || undefined, limit },
    },
  );
  return response.data;
};
